import merge from 'lodash/merge';
import localeText from './localeText';
import PerPageSize from '../../common/ag-grid/pagination/PerPageOption';

export default function defaultGridOptionsTable(overrides) {
  const defaults = {
    defaultColDef: {
      suppressHeaderMenuButton: true,
      filter: true,
      resizable: false,
      sortable: false,
    },
    enableBrowserTooltips: true,
    localeText: localeText(),
    onFirstDataRendered: (event) => {
      event.api.sizeColumnsToFit();
    },
    onGridSizeChanged: (event) => {
      event.api.sizeColumnsToFit();
    },
    pagination: true,
    paginationPageSize: PerPageSize.TWENTY_FIVE,
    sendToClipboard: () => null,
    sortingOrder: ['desc', 'asc', null],
    stopEditingWhenCellsLoseFocus: true,
    suppressCellFocus: true,
    suppressContextMenu: true,
    suppressMovableColumns: true,
    suppressPaginationPanel: true,
    unSortIcon: true,
  };
  return merge(defaults, overrides);
}
